var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormbuilderDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 3.5625H14.8125M3.5625 6.375H20.4375M18.5625 6.375L17.905 16.2368C17.8064 17.7164 17.7571 18.4562 17.4375 19.0172C17.1562 19.5111 16.7318 19.9081 16.2203 20.156C15.6393 20.4375 14.8979 20.4375 13.415 20.4375H10.585C9.1021 20.4375 8.36065 20.4375 7.77969 20.156C7.26821 19.9081 6.84383 19.5111 6.56248 19.0172C6.24292 18.4562 6.1936 17.7164 6.09496 16.2368L5.4375 6.375M10.125 10.5938V15.2812M13.875 10.5938V15.2812",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormbuilderDelete);
export default __webpack_public_path__ + "static/media/formbuilderDelete.2c24c1276bb4319bea2801a9fe83c3cc.svg";
export { ForwardRef as ReactComponent };